import { render, staticRenderFns } from "./side_nav.vue?vue&type=template&id=4e9a879d&scoped=true&"
import script from "./side_nav.vue?vue&type=script&lang=js&"
export * from "./side_nav.vue?vue&type=script&lang=js&"
import style0 from "./side_nav.vue?vue&type=style&index=0&id=4e9a879d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a879d",
  null
  
)

export default component.exports